import React from "react";

export const TogglerContext = React.createContext({});
